import React, { useEffect, useState } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const Header = () => {
  const location = useLocation();

  const [activePath, setActivePath] = useState("/");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    setActivePath(location.pathname);
    switch (location.pathname) {
      case "/privacy-policy":
      case "/features":
        toggleBodyOverflow(true);
        break;
      default:
        toggleBodyOverflow(false);
    }
  }, [location.pathname]);

  function toggleBodyOverflow(shouldHide) {
    if (shouldHide) {
      document.body.style.overflowX = "hidden";
    } else {
      document.body.style.overflowX = "auto"; // or 'scroll', depending on the desired behavior
    }
  }

  return (
    <header className="header">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
            <Link to="/" style={{textDecoration:"none",color:"white"}}>
        <div className="logo">
    
            <div className="burger-menu" onClick={toggleMenu}>
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
            </div>
            <img src="ic_logo.png" alt="GrowTube Logo" />
            <h1>Grow Tube</h1>
   
        </div>
        </Link>
      </div>

      <nav className={`nav ${isMenuOpen ? "" : "open"}`}>
        <ul className="nav-list">
          <li>
            <Link to={"/"}>Home</Link>
            <div className={activePath === "/" ? "active-tab " : ""}></div>
          </li>
          <li>
            <Link to={"/features"}>Features</Link>
            <div
              className={activePath === "/features" ? "active-tab " : ""}
            ></div>
          </li>
          {/* <li><a href="/overview">Overview</a></li> */}
          <li>
            <Link to={"/privacy-policy"}>Privacy Policy</Link>
            <div
              className={activePath === "/privacy-policy" ? "active-tab " : ""}
            ></div>
          </li>
          <li>
            <Link to={"/contact"}>Contact</Link>
            <div
              className={activePath === "/contact" ? "active-tab " : ""}
            ></div>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
